interface IconProps {
  color?: string
  className?: string
}

export default function WalletTabIcon({ color, className }: IconProps) {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.6055 2.625C13.3711 2.625 14 3.22656 14 3.9375V10.9375C14 11.6758 13.3711 12.25 12.6055 12.25H1.75C0.765625 12.25 0 11.4844 0 10.5V1.75C0 0.792969 0.765625 0 1.75 0H11.8125C12.5234 0 13.125 0.601562 13.125 1.3125C13.125 1.55859 12.9062 1.75 12.6875 1.75H2.1875C1.94141 1.75 1.75 1.96875 1.75 2.1875C1.75 2.43359 1.94141 2.625 2.1875 2.625H12.6055ZM11.375 8.3125C11.8398 8.3125 12.25 7.92969 12.25 7.4375C12.25 6.97266 11.8398 6.5625 11.375 6.5625C10.8828 6.5625 10.5 6.97266 10.5 7.4375C10.5 7.92969 10.8828 8.3125 11.375 8.3125Z"
        fill={color ?? '#ffffff'}
      />
    </svg>
  )
}
